import { printValue, setLocale } from 'yup';

export function createLocalizedMessagesForYup(t: (key: string, options?: any) => string): void {
	setLocale({
		mixed: {
			default: ({ path, label }) => t('Validation.isInvalid', { '0': label || path }),
			required: ({ path, label }) => t('Validation.yupRequired', { '0': label || path }),
			defined: ({ path, label }) => t('Validation.defined', { '0': label || path }),
			notNull: ({ path, label }) => t('Validation.notNull', { '0': label || path }),
			oneOf: ({ path, label, values }) => t('Validation.oneOf', { '0': label || path, '1': values }),
			notOneOf: ({ path, label, values }) => t('Validation.notOneOf', { '0': label || path, '1': values }),
			notType: ({ path, label, type, value }) => {
				let msg = t('Validation.notType', {
					'0': label || path,
					'1': type,
					'2': printValue(value, true)
				});

				if (value === null) {
					msg += t('Validation.nullableTip');
				}

				return msg;
			}
		},
		string: {
			length: ({ path, label, length }) => t('Validation.yupStringLength', { '0': label || path, '1': length }),
			min: ({ path, label, min }) => t('Validation.yupStringMin', { '0': label || path, '1': min }),
			max: ({ path, label, max }) => t('Validation.yupStringMax', { '0': label || path, '1': max }),
			matches: ({ path, label, regex }) => t('Validation.matches', { '0': label || path, '1': regex }),
			email: ({ path, label }) => t('Validation.yupEmail', { '0': label || path }),
			url: ({ path, label }) => t('Validation.url', { '0': label || path }),
			uuid: ({ path, label }) => t('Validation.uuid', { '0': label || path }),
			trim: ({ path, label }) => t('Validation.trim', { '0': label || path }),
			lowercase: ({ path, label }) => t('Validation.lowercase', { '0': label || path }),
			uppercase: ({ path, label }) => t('Validation.uppercase', { '0': label || path })
		},
		number: {
			min: ({ path, label, min }) => t('Validation.yupNumberMin', { '0': label || path, '1': min }),
			max: ({ path, label, max }) => t('Validation.yupNumberMax', { '0': label || path, '1': max }),
			lessThan: ({ path, label, less }) => t('Validation.lessThan', { '0': label || path, '1': less }),
			moreThan: ({ path, label, more }) => t('Validation.moreThan', { '0': label || path, '1': more }),
			positive: ({ path, label }) => t('Validation.positive', { '0': label || path }),
			negative: ({ path, label }) => t('Validation.negative', { '0': label || path }),
			integer: ({ path, label }) => t('Validation.integer', { '0': label || path })
		},
		date: {
			min: ({ path, label, min }) => t('Validation.yupDateMin', { '0': label || path, '1': min }),
			max: ({ path, label, max }) => t('Validation.yupDateMax', { '0': label || path, '1': max })
		},
		object: {
			noUnknown: ({ path, label, unknown }) => t('Validation.noUnknown', { '0': label || path, '1': unknown })
		},
		array: {
			min: ({ path, label, min }) => t('Validation.yupArrayMin', { '0': label || path, '1': min }),
			max: ({ path, label, max }) => t('Validation.yupArrayMax', { '0': label || path, '1': max }),
			length: ({ path, label, length }) => t('Validation.yupArrayLength', { '0': label || path, '1': length })
		},
		boolean: {
			isValue: ({ path, label, value }) => t('Validation.boolean.isValue', { '0': label || path, '1': value })
		}
	});
}
